<template>
  <div class="header-menu">
    <div
      class="menu-item"
      v-for="(item, index) in menu"
      :key="index"
      @mouseenter="onMouseEnter(item)"
      @mouseleave="onMouseLeave(item)"
      @click="goto(item)"
    >
      {{item.name}}
      <div class="submenu" v-show="item.hover && item.path != path" v-if="item.list.length > 0">
        <div class="tri"></div>
        <div class="con">
          <div
            class="submenu-item"
            v-for="(item, index) in item.list"
            :key="index"
            @click.stop="goto(item)"
          >{{item.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderMenu",
  data() {
    return {
      path: "/",
      menu: [
        {
          id: 1,
          name: "首页",
          path: "/liquor/index",
          list: [],
          hover: false
        },
        {
          id: 2,
          name: "涨姿势",
          path: "/liquor/country",
          list: [],
          hover: false
        },
        {
          id: 3,
          name: "做大拿",
          path: "/liquor/dana",
          list: [
            {
              name: "专业词汇",
              path: "/liquor/dana"
            },
            {
              name: "知识挑战",
              path: "/liquor/game"
            }
          ],
          hover: false
        },
        {
          id: 4,
          name: "品美酒",
          path: "/liquor/browser",
          list: [],
          hover: false
        },
        {
          id: 5,
          name: "造生活",
          path: "/liquor/life",
          list: [],
          hover: false
        }
      ]
    };
  },
  methods: {
    onMouseEnter(item) {
      item.hover = true;
    },
    onMouseLeave(item) {
      item.hover = false;
    },
    goto(item) {
      this.$router.push(item.path);
    }
  }
};
</script>

<style lang="scss" scoped>
.header-menu {
  display: flex;

  background: black;

  .menu-item {
    font-size: 14px;
    font-weight: 400;
    color: rgba(228, 200, 150, 1);
    padding: 0 10px;
    height: 70px;
    line-height: 70px;
    opacity: 0.7;

    cursor: pointer;

    position: relative;

    .submenu {
      position: absolute;
      top: 110px;
      left: 50%;
      transform: translate(-50%, -50%);

      box-shadow: 0px 9px 18px 0px rgba(0, 0, 0, 0.14);

      .tri {
        margin-bottom: -1px;
        margin-left: 10px;
        width: 0;
        height: 0;
        border-width: 0 7.5px 7.5px;
        border-style: solid;
        border-color: transparent transparent rgba(228, 200, 150, 1);
      }

      .con {
        width: 90px;
        padding: 5px;
        background: rgba(228, 200, 150, 1);
      }

      .submenu-item {
        width: 90px;
        margin: 10px 0;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        color: #3b2909;
        text-align: center;
      }

      .submenu-item:hover {
        background: rgba(59, 41, 9, 1);
        color: #e4c896;
      }
    }
  }

  .menu-item:hover {
    opacity: 1;
    font-weight: 600;
    background: rgba(0, 0, 0, 0);
  }
}
</style>